/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Тип организации аккаунта
 * @export
 * @enum {string}
 */
export enum OrganizationType {
  IndividualBusinessman = 'INDIVIDUAL_BUSINESSMAN',
  ForeignCompany = 'FOREIGN_COMPANY',
  LegalEntity = 'LEGAL_ENTITY',
  IndividualEntity = 'INDIVIDUAL_ENTITY',
}

export function instanceOfOrganizationType(value: any): boolean {
  for (const key in OrganizationType) {
    if (Object.prototype.hasOwnProperty.call(OrganizationType, key)) {
      if (OrganizationType[key as keyof typeof OrganizationType] === value) {
        return true
      }
    }
  }
  return false
}

export function OrganizationTypeFromJSON(json: any): OrganizationType {
  return OrganizationTypeFromJSONTyped(json, false)
}

export function OrganizationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganizationType {
  return json as OrganizationType
}

export function OrganizationTypeToJSON(value?: OrganizationType | null): any {
  return value as any
}
